import { Injectable } from '@angular/core';
import { Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable} from 'rxjs';
import { ObservableService } from './observable.service';


@Injectable({
  providedIn: 'root'
})
export class IsCardCodeResolver implements Resolve<boolean> {
  constructor(private observableService: ObservableService) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.observableService.getIsCardCodeOk();
  }
}
